import { render, staticRenderFns } from "./JobPayments.vue?vue&type=template&id=4d1f8dea"
import script from "./JobPayments.vue?vue&type=script&lang=ts"
export * from "./JobPayments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports